import {APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners,} from '@angular/core';
import {provideHttpClient} from '@angular/common/http';
import {provideRouter, Router, withInMemoryScrolling} from '@angular/router';
import {provideServiceWorker} from '@angular/service-worker';
import * as Sentry from '@sentry/angular';
import {provideNgxStripe} from 'ngx-stripe';

import {environment} from '../environments/environment';
import {routes} from './app.routes';
import {appI18nProviders} from './i18n/i18n.providers';
import {ConsentService} from './services/consent.service';
import {DirectBookingEntryParametersService} from './services/direct-booking-entry-parameters.service';
import {KeycloakService} from './services/keycloak.service';

/**
 * Factory function for Keycloak initialization
 */
export function initializeKeycloak(keycloak: KeycloakService) {
  return () => keycloak.init();
}

export function initializeDirectBookingEntryParameters(
  entryParameters: DirectBookingEntryParametersService,
) {
  return () => entryParameters.persistFromCurrentUrl();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
    ),
    provideHttpClient(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.name !== 'local',
      registrationStrategy: 'registerWhenStable:30000',
    }),
    ...appI18nProviders,
    provideNgxStripe(environment.stripe.publicKey),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (consentService: ConsentService) => () => consentService.initialize(),
      deps: [ConsentService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeDirectBookingEntryParameters,
      deps: [DirectBookingEntryParametersService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      deps: [KeycloakService],
      multi: true,
    },
  ],
};
